
import './App.css';
import { Box, Button } from '@mui/material';
import { useState } from 'react';

import sad01 from './assets/sad01.gif'
import sad02 from './assets/sad02.gif'
import sad03 from './assets/sad03.gif'
import sad04 from './assets/sad04.gif'
import sad05 from './assets/sad05.gif'
import sad06 from './assets/sad06.gif'

import yes from './assets/yes.gif'
import hoh from './assets/hearts-of-happiness-hearts.gif'

import wh00 from './assets/wh00.jpeg'
import wh01 from './assets/wh01.jpeg'
import wh02 from './assets/wh02.jpeg'

import wh10 from './assets/wh10.jpeg'
import wh11 from './assets/wh11.jpeg'
import wh12 from './assets/wh12.jpeg'

import wh20 from './assets/wh20.jpeg'
import wh21 from './assets/wh21.jpeg'
import wh22 from './assets/wh22.jpeg'

import wh30 from './assets/wh30.jpeg'
import wh31 from './assets/wh31.jpeg'
import wh32 from './assets/wh32.jpeg'


function App() {
  const [noScale, setNoScale] = useState(1)
  const [yesScale, setYesScale] = useState(1)
  const [messageIndex, setMessageIndex] = useState(0)

  const [imgSrc, setImageSrc] = useState(null)
  const [done, setDone] = useState(false)

  const handleYes = () => {
    setImageSrc(yes)
    setDone(true)
    setMessageIndex(1)
  }
  const handleNO = () => {
    setYesScale(yesScale+0.1*yesScale)
    setNoScale(noScale-0.1*noScale)
    if(messageIndex<6){
      setMessageIndex(messageIndex+1)
      setImageSrc(gifArr[messageIndex])
    }
    
  }

  const gifArr = [
    sad01,
    sad02,
    sad03,
    sad04,
    sad05,
    sad06
  ]

  const yesArr = [
    'Yes',
    'Please Say Yes',
    'Please Say Yes',
    'Please Press Me',
    'Poochu Sad Please Say Yes',
    'Press This Button Please Say Yes',
    'Poochu Nobh Uh, Please Say Yes',''
  ]

  const noArr = [
    'No',
    'Are You Sure?',
    'Are You Really Sure?',
    'Please Reconsider',
    'Please Reconsider Once More',
    'Please Look At The Button Over Left',
    'Please Say Yes'
  ]




  return (
    <div className="App">
      <Box sx={{display: 'flex', flexDirection: 'column', width: '100%'}}>
        {messageIndex?(<Box sx={{padding: 0, alignItems:'center', justifyContent: 'center'}}>
          <img src={imgSrc} width={300} height={300} alt='GIFS'/>
        </Box>):(<></>)}
        {done?(<></>):(<><Box sx={{padding: 10}}>
          Will you be my Valentine?
        </Box>
        <Box sx={{display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'space-evenly', alignItems: 'center'}}>
          <Button variant='contained' sx = {{height:150*yesScale, width: 150*yesScale}} onClick={() => {handleYes()}}>{yesArr[messageIndex]}</Button>
          <Button color='error' variant='contained' sx = {{height:150*noScale, width: 150*noScale}} onClick={()=>{handleNO()}}>{noArr[messageIndex]}</Button>
        </Box></>)}
      </Box>
      {done && (<>
        <Box sx={{zIndex: 100, display: 'flex', width: '100%', height: '100vh', position: 'fixed', opacity: 0.1, backgroundImage: `url(${hoh})`, backgroundPosition: 'center',backgroundSize: 'cover',}}/>
        <Box sx={{zIndex: 200, display: 'flex', width: '100%', height: '100vh', position: 'fixed', opacity: 0.31, flexDirection: 'row', backgroundColor: 'white'}}>
          <Box className='COL_1'  sx={{width: '25%', height: '100%', display: 'flex', flexDirection: 'column', padding: 1}}>
            <Box sx={{width: '100%', height: '50%', aspectRatio: 1,  backgroundImage: `url(${wh00})`, marginTop: 1, backgroundPosition: 'center',backgroundSize: 'cover'}} />
            <Box sx={{width: '100%', height: '50%', aspectRatio: 1,  backgroundImage: `url(${wh01})`, marginTop: 1, backgroundPosition: 'center',backgroundSize: 'cover'}} />
            <Box sx={{width: '100%', height: '50%', aspectRatio: 1,  backgroundImage: `url(${wh02})`, marginTop: 1, backgroundPosition: 'center',backgroundSize: 'cover'}} />
            <Box sx={{width: '100%', height: '50%', aspectRatio: 1,  backgroundImage: `url(${wh00})`, marginTop: 1, backgroundPosition: 'center',backgroundSize: 'cover'}} />
            <Box sx={{width: '100%', height: '50%', aspectRatio: 1,  backgroundImage: `url(${wh01})`, marginTop: 1, backgroundPosition: 'center',backgroundSize: 'cover'}} />
            <Box sx={{width: '100%', height: '50%', aspectRatio: 1,  backgroundImage: `url(${wh02})`, marginTop: 1, backgroundPosition: 'center',backgroundSize: 'cover'}} />
          </Box>
          <Box className='COL_2' sx={{width: '25%', display: 'flex', flexDirection: 'column', padding: 1}}>
            <Box sx={{width: '100%', height: '50%', aspectRatio: 1,  backgroundImage: `url(${wh10})`, marginTop: 1, backgroundPosition: 'center',backgroundSize: 'cover'}} />
            <Box sx={{width: '100%', height: '50%', aspectRatio: 1,  backgroundImage: `url(${wh11})`, marginTop: 1, backgroundPosition: 'center',backgroundSize: 'cover'}} />
            <Box sx={{width: '100%', height: '50%', aspectRatio: 1,  backgroundImage: `url(${wh12})`, marginTop: 1, backgroundPosition: 'center',backgroundSize: 'cover'}} />
            <Box sx={{width: '100%', height: '50%', aspectRatio: 1,  backgroundImage: `url(${wh10})`, marginTop: 1, backgroundPosition: 'center',backgroundSize: 'cover'}} />
            <Box sx={{width: '100%', height: '50%', aspectRatio: 1,  backgroundImage: `url(${wh11})`, marginTop: 1, backgroundPosition: 'center',backgroundSize: 'cover'}} />
            <Box sx={{width: '100%', height: '50%', aspectRatio: 1,  backgroundImage: `url(${wh12})`, marginTop: 1, backgroundPosition: 'center',backgroundSize: 'cover'}} />
          </Box>
          <Box className='COL_3' sx={{width: '25%', display: 'flex', flexDirection: 'column', padding: 1}}>
            <Box sx={{width: '100%', height: '50%', aspectRatio: 1,  backgroundImage: `url(${wh20})`, marginTop: 1, backgroundPosition: 'center',backgroundSize: 'cover'}} />
            <Box sx={{width: '100%', height: '50%', aspectRatio: 1,  backgroundImage: `url(${wh21})`, marginTop: 1, backgroundPosition: 'center',backgroundSize: 'cover'}} />
            <Box sx={{width: '100%', height: '50%', aspectRatio: 1,  backgroundImage: `url(${wh22})`, marginTop: 1, backgroundPosition: 'center',backgroundSize: 'cover'}} />
            <Box sx={{width: '100%', height: '50%', aspectRatio: 1,  backgroundImage: `url(${wh20})`, marginTop: 1, backgroundPosition: 'center',backgroundSize: 'cover'}} />
            <Box sx={{width: '100%', height: '50%', aspectRatio: 1,  backgroundImage: `url(${wh21})`, marginTop: 1, backgroundPosition: 'center',backgroundSize: 'cover'}} />
            <Box sx={{width: '100%', height: '50%', aspectRatio: 1,  backgroundImage: `url(${wh22})`, marginTop: 1, backgroundPosition: 'center',backgroundSize: 'cover'}} />
          </Box>
          <Box className='COL_4' sx={{width: '25%', display: 'flex', flexDirection: 'column', padding: 1}}>
            <Box sx={{width: '100%', height: '50%', aspectRatio: 1,  backgroundImage: `url(${wh30})`, marginTop: 1, backgroundPosition: 'center',backgroundSize: 'cover'}} />
            <Box sx={{width: '100%', height: '50%', aspectRatio: 1,  backgroundImage: `url(${wh31})`, marginTop: 1, backgroundPosition: 'center',backgroundSize: 'cover'}} />
            <Box sx={{width: '100%', height: '50%', aspectRatio: 1,  backgroundImage: `url(${wh32})`, marginTop: 1, backgroundPosition: 'center',backgroundSize: 'cover'}} />
            <Box sx={{width: '100%', height: '50%', aspectRatio: 1,  backgroundImage: `url(${wh30})`, marginTop: 1, backgroundPosition: 'center',backgroundSize: 'cover'}} />
            <Box sx={{width: '100%', height: '50%', aspectRatio: 1,  backgroundImage: `url(${wh31})`, marginTop: 1, backgroundPosition: 'center',backgroundSize: 'cover'}} />
            <Box sx={{width: '100%', height: '50%', aspectRatio: 1,  backgroundImage: `url(${wh32})`, marginTop: 1, backgroundPosition: 'center',backgroundSize: 'cover'}} />
          </Box>
        </Box>
      </>)}
    </div>
  );
}

export default App;
